import ApplicationController from './application_controller'

// Several lots in one transport estimate. The search filter only hides cards,
// so a checked lot it hides stays selected. The url value carries the literal
// SKUS where the checked SKUs go.
export default class extends ApplicationController {
  static targets = ['checkbox', 'bar', 'count', 'estimate']
  static values = { url: String, one: String, other: String }

  connect () {
    this.update()
  }

  update () {
    const skus = this.checkboxTargets.filter((box) => box.checked).map((box) => box.value)
    const label = skus.length === 1 ? this.oneValue : this.otherValue

    this.barTarget.hidden = skus.length === 0
    this.countTarget.textContent = label.replace('%{count}', skus.length)
    this.estimateTarget.dataset.widgetModalUrlParam =
      this.urlValue.replace('SKUS', skus.map(encodeURIComponent).join(','))
  }
}
